import Backbone from 'backbone'
import _ from 'lodash'
import selects from 'scoreboard/components/selects'

/**
 * Renders a native select (styled like a rich select) that turns into a rich
 * filtering select when the user clicks on it. This is to improve performance
 * when hundreds of rich selects are on the screen. See #32514 for discussion.
 */
const LazyFilteringSelect = Backbone.View.extend({
	events: {
		'mousedown': 'onMousedown'
	},

	/**
	 * @param {Object} options
	 *
	 * @param {jQuery|Element} el - a wrapper div with the classes "select-wrap lazy-select"
	 * and containing the <select> element that will eventually be rich. Right now, it's
	 * required to pass in elements like this, but if future need arises, we can allow
	 * this component to render those elements if not provided.
	 *
	 * @param {Function} getSelectOptions - function which returns a list of options that should be rendered
	 * in the select. See scoreboard-select for details, but the format will
	 * generally be [{ value: 'something', label: 'Some Option' }]
	 *
	 * @param {Object} filteringOptions - options that are passed to selects.filtering(),
	 * see that module for details
	 */
	initialize: function (options = {}) {
		this.options = options
	},

	render: function () {
		this.renderNative()
		return this
	},

	onMousedown: function (e) {
		if (this.rich) {
			return
		}

		// preventDefault on the mousedown (instead of click) will prevent the
		// native select's dropdown from briefly opening
		e.preventDefault()

		this.$el.removeClass('select-wrap')

		// Empty out the select and reset its value so the filteringSelect
		// can initialize things properly
		this.$('select').empty().val('')
		this.renderFiltering({ open: true })
	},

	renderNative: function () {
		let select = this.$('select')
		// #32514 We currently don't have a need to render any option other than
		// the currently selected one; when the user clicks on the select, it will
		// turn into a filtering select (which _will_ render all the options).
		// This dramatically improves performance when rendering hundrends/thousands
		// of selects.
		//
		// If, however, we ever need to change the selected value without calling
		// updateOptions() again (like another component using formHelper.writeToDom()),
		// we'll need to reconsider this.
		let selectedOption =
			this.options.selectedOption ??
			this.options.getSelectOptions({
				findPredicate: opt => opt.selected
			})[0]
		if (selectedOption?.selected) {
			let domOptions = select[0].options
			if (domOptions.length === 0) {
				domOptions.add(new Option(selectedOption.label, selectedOption.value))
			} else {
				let domOption = domOptions.item(0)
				domOption.value = selectedOption.value
				domOption.text = selectedOption.label
			}
		} else {
			select.empty()
		}

		if (!_.isNil(selectedOption)) {
			select[0].value = selectedOption.value
		}
	},

	renderFiltering: function (opt = {}) {
		let select = this.$('select')
		const scoreboardSelectOptions = _.extend({
			options: this.options.getSelectOptions(),
			autofocus: !!opt.open,
			open: !!opt.open,
			nativeSupport: false
		}, this.options.filteringOptions)

		selects.filtering(select, scoreboardSelectOptions)

		this.rich = true
		this.trigger('rendered')
	}
})

export default LazyFilteringSelect

LazyFilteringSelect.__filename__ = 'components/lazy-filtering-select.js'
